import React, {useState, useEffect} from 'react'
import {Typography, Button, Space, Input, Row} from 'antd'
import {Link} from 'react-router-dom'
import {PlusCircleFilled} from '@ant-design/icons'
import moment from 'moment'


import {useQuery} from 'react-query'

import * as Queries from 'queries/ratings.queries'
import {QUERIES} from 'constants/index'
import DataTable from 'components/DataTable'

import * as Styled from './ratings-styled'
import axios from 'axios'
import fileDownload from 'js-file-download'
import { ReloadOutlined } from '@ant-design/icons'

const {Title} = Typography

function Ratings() {
    const columns = [
        {
            title: ' ID',
            dataIndex: 'id',
            key: 'ratingId',
            render: val => <Link to={`/ratings/${val}`}>{val}</Link>,
            sorter: (a, b) => a.id - b.id,
            width: 110,
        },
        {
            title: 'Order ID',
            dataIndex: 'order_id',
            key: 'order_id',
            render: val => <Link to={`/booking/${val}`}>{val}</Link>,
        },
        {
            title: 'Rated',

            key: 'rated_name',
            render: val => (
                <Link style={{textTransform:'capitalize'}} to={`/user/${val.rated_id}`}>{val.rated_name}</Link>
            ),
        },
        {
            title: 'Rater',

            key: 'rater_name',
            render: val => (
                <Link style={{textTransform:'capitalize'}} to={`/user/${val.rater_id}`}>{val.rater_name}</Link>
            ),
        },

        {
            title: 'Score',
            dataIndex: 'score',
            key: 'score',
            render: val => val || 'N/A',
        },
        {
            title: 'Review',
            dataIndex: 'review',
            key: 'review',
            render: val => val || 'N/A',
        },
    ]

    const [enabled, setEnabled] = useState(false)
    const [filters, setFilters] = useState({
        raterName: '',
        ratedName: '',
        score: '',
    })
    const filterQuery = useQuery(
        [QUERIES.GET_ALL_RATING, 0, filters],
        Queries.getAllRating,
        {
            staleTime: 180000,
            filters: enabled,
            enabled,
        },
    )

    /*
     * function to update the whole filtering data in the user page
     * {param} key: any string value representing the property of filters variable which is to be updated
     * {param} value: the value of that particular property of the filter
     */
    const onFiltersChange = (key, value) => {
        setFilters(values => {
            console.log(value)
            return {
                ...values,
                [key]: value,
            }
        })
    }
    const getAndSaveUserData = () => {
        filterQuery.refetch({
            queryKey: [QUERIES.GET_ALL_RATING, 0, filters],
        })
    }
    // a function which will be used to clear all the filters to search user
    const onResetFilters = () => {
        setFilters({
            email: '',
            fullname: '',
            telephone: '',
        })
    }

    useEffect(() => {
        if (filters.raterName || filters.ratedName || filters.score)
            setEnabled(true)
        else setEnabled(false)
    }, [filters])

    // function to export csv
    const [csv, setCsv] = useState(false)

    function downloadCsv(e) {
        e.preventDefault()
        setCsv(true)
        const token = localStorage.getItem('token')
        const csvDate = moment(new Date()).format('DD_MM_YYYY')

        axios
            .get(`${process.env.REACT_APP_BASE_URL}/admin/rating/csv`, {
                headers: {
                    Authorization: token,
                },
            })
            .then(res => {
                fileDownload(res.data, `Ratings_${csvDate}.csv`)
                setCsv(false)
            })
            .catch(err => {
                console.log(err)
                setCsv(false)
            })
    }

    function  reloadApi(){
        filterQuery.refetch({
            queryKey:[QUERIES.GET_ALL_RATING, 0, filters],
        })
    }

    return (
        <>
        <div style={{ textAlign: 'right', marginRight: '30px', marginBottom: '5px' }}> 
            <Button icon={<ReloadOutlined />} style={{textAlign:'right'}}   onClick={reloadApi} type="primary">Reload</Button>
        </div>
        <div>
            <Styled.FilterCollapse bordered ghost>
                <Styled.FilterCollapsePanel
                    header={<Title level={5}>Filters (click to toggle)</Title>}>
                    <Space direction="vertical">
                        {/* email filtering inputs */}
                        <Row align="middle" gutter={10}>
                            <Space direction="horizontal">
                                <Input
                                    allowClear
                                    value={filters.raterName}
                                    placeholder="Rater Name"
                                    onChange={e =>
                                        onFiltersChange(
                                            'raterName',
                                            e.target.value,
                                        )
                                    }
                                />

                                <Input
                                    allowClear
                                    value={filters.ratedName}
                                    placeholder="Rated Name"
                                    onChange={e =>
                                        onFiltersChange(
                                            'ratedName',
                                            e.target.value,
                                        )
                                    }
                                />

                                <Input
                                    allowClear
                                    value={filters.score}
                                    placeholder="Score"
                                    onChange={e =>
                                        onFiltersChange('score', e.target.value)
                                    }
                                />

                                <Button
                                    disabled={!Object.keys(filters).length > 0}
                                    onClick={getAndSaveUserData}
                                    type="primary">
                                    Search
                                </Button>
                                <Button
                                    disabled={!Object.keys(filters).length > 0}
                                    onClick={onResetFilters}
                                    type="ghost"
                                    danger>
                                    Reset Filters
                                </Button>
                            </Space>
                        </Row>
                    </Space>
                </Styled.FilterCollapsePanel>
            </Styled.FilterCollapse>

            <DataTable
                forceData={
                    false
                    // enabled &&
                    // filterQuery.isSuccess &&
                    // filterQuery.data.data &&
                    // filterQuery.data.data.count >= 0
                }
                columns={columns}
                filters={filters}
                queryFunction={Queries.getAllRating}
                queryKey={QUERIES.GET_ALL_RATING}
            />

            <Button
                style={{margin: '2rem', minHeight: '45px', display: 'flex'}}
                onClick={e => downloadCsv(e)}
                loading={csv}
                type="light">
                <img
                    style={{width: '35px', height: '35px', marginRight: '5px'}}
                    src="/csb.png"
                    alt=""
                />
                Download CSV
            </Button>
        </div>
      </>
    )
}

export default Ratings
